@use '../../design-tokens/typography/typography' as *;
@use '../../design-tokens/breakpoints/breakpoints' as *;

@layer design-system {
  .alert {
    display: flex;
    position: relative;
    border-radius: 4px;
    color: var(--text-default);
    padding: 16px;
    width: 343px;
    max-width: 100%;

    @include respond-to('xs') {
      width: 480px;
    }

    @include respond-to('xlg') {
      width: 600px;
    }

    svg {
      display: block;
    }
  }

  .variantInline {
    padding: 16px 16px 16px 13px;

    &.typeError {
      border-left: 4px solid var(--border-critical);
    }

    &.typeWarning {
      border-left: 4px solid var(--border-warning);
    }

    &.typeSuccess {
      border-left: 4px solid var(--border-success);
    }

    &.typeInfo {
      border-left: 4px solid var(--border-default);
    }
  }

  .variantToast {
    &.typeError {
      border: 1px solid var(--border-critical);
    }

    &.typeWarning {
      border: 1px solid var(--border-warning);
    }

    &.typeSuccess {
      border: 1px solid var(--border-success);
    }

    &.typeInfo {
      border: 1px solid var(--border-default);
    }
  }

  .typeSuccess {
    background-color: var(--surface-success);
  }

  .typeWarning {
    background-color: var(--surface-warning);
  }

  .typeError {
    background-color: var(--surface-critical);
  }

  .typeInfo {
    background-color: var(--surface-default);
  }

  .content {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    font-size: 0.938rem;

    @include respond-to('lg') {
      font-size: 0.875rem;
    }
  }

  .title {
    @include typography-v2-title-sm;
    flex-grow: 1;
  }

  .contentSection {
    display: flex;
    justify-content: space-between;
  }

  .textWrapper {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .message {
    @include typography-v2-body-sm;
  }

  .close {
    cursor: pointer;
    border: none;
    background: none;
    margin-left: 12px;
    padding: 4px;

    svg {
      fill: var(--icon-soft);
    }

    &:hover svg {
      fill: var(--icon-default);
    }
  }

  .buttonsContainer {
    display: flex;
    margin-top: 12px;

    > button:first-child {
      margin-right: 8px;
    }
  }

  .icon {
    margin-right: 8px;
  }
}
